import useMountEffect from '@restart/hooks/useMountEffect';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import actions from '@/actions';
import API from '@/helpers/API';

const matchesFilters = (robot, filters) => {
  return filters.every(({ field, value }) => {
    const fieldValue = field.split('.').reduce((object, key) => object[key], robot);
    return value === fieldValue;
  });
};

const useLoadRobots = (filters = [], callback) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useMountEffect(() => {
    // API: 로봇내역 조회
    API.get('/robots')
      .then(({ success, data }) => {
        if (!success) throw new Error();

        const filtered = data.filter((robot) => matchesFilters(robot, filters));
        dispatch(actions.robots.load(filtered));

        // callback 정의 시 실행
        callback?.(filtered);
      })
      .catch((_e) => {
        // 에러 시 빈 목록과 동일하게 처리
        dispatch(actions.robots.load([]));
      })
      .finally(() => {
        setIsLoading(false);
      });
  });

  return { isLoading };
};

export default useLoadRobots;
